import { Component, OnInit, ElementRef, Inject } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl, FormArray, UntypedFormBuilder, NgForm } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { HttpErrorResponse } from "@angular/common/http";
import { RegisterService } from "../../services/register.service";
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../services/user.service";
import { GlobalService } from "../../services/global.service";
import { DialogService } from "../../services/dialog.service";

import { parsePhoneNumberFromString as parseMobile, AsYouType, getCountries, getCountryCallingCode } from "libphonenumber-js/mobile";
import { RecaptchaComponent } from "ng-recaptcha";
import { resourceUsage } from "process";

@Component({
    selector: "sd-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
})


export class RegisterComponent implements OnInit {
    CTALabel = 'Submit'
    registerForm: UntypedFormGroup;
    cityForm: UntypedFormGroup;
    artistTypeForm: UntypedFormGroup;
    listenerForm: UntypedFormGroup;
    formSteps: number = 1;
    // showCity: Boolean = false;
    regType: string = 'Artist';
    genres = [];
    artistTypes = [];
    countries = [];
    states = [];
    cities = [];
    buttonPressed: Boolean;
    showForm3: Boolean = true;
    counter: number = 0;
    reCaptcha: RecaptchaComponent;
    selectedArtistType = [];


    isEmailExist: Boolean = false;
    isUsernameExist: Boolean = false;
    suggestion = "";
    registerError: Boolean = false;
    registerErrorMsg = "";
    registerLoading: Boolean = false;
    recaptchaError: Boolean = false;
    listernRecaptchaError: Boolean = false;
    isListenerFormSubmitted: Boolean = false;
    isCityFormSubmitted: Boolean = false;
    isRegisterFormSubmitted: Boolean = false;
    emailVerificationOpen: Boolean = false;
    formValue: any;
    windowWidth: any;
    loginRedirectPage = "";
    isartistFormSubmitted: Boolean = false;
    externalRedirect = "";
    buttonclicked: Boolean = false;
    isSelected = true;
    type = 'Artist';
    checkboxError: boolean = false;
    CountryValue: any;
    StateValue: any;
    CityValue: any;
    searchCountry: any
    searchState: any;
    searchCity: any;
    subscriptionRouteArray = ['checkout']
    skipEmailVerification = false;
    invalidEmailError: Boolean = false;


    // showstate: boolean = false;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private api: ApiService,
        private user: UserService,
        private el: ElementRef,
        public register: RegisterService,
        private router: Router,
        private fb: UntypedFormBuilder,
        private route: ActivatedRoute,
        public global: GlobalService,
        public dialog: DialogService,
        private matDialog: MatDialog,
        private registerDialogRef: MatDialogRef<RegisterComponent>,

    ) {


        //
        if (data.formStep == '2') {
            this.formSteps = 2;
        } else if (data.formStep == '3') {
            this.formSteps = 3
        } else {
            this.formSteps = 1
        }
        this.route.queryParams.subscribe((res) => {
            this.loginRedirectPage = res.login;

            if (res.externalRedirect) {
                this.externalRedirect = res.externalRedirect;
            }
        });

        this.global.setMeta({});



        this.cityForm = new UntypedFormGroup({
            country: new UntypedFormControl("", [Validators.required]),
            state: new UntypedFormControl("", [Validators.required]),
            otherState: new UntypedFormControl("Other", [Validators.required]),
            city: new UntypedFormControl("", [Validators.required]),
            otherCity: new UntypedFormControl(""),
        });
        this.cityForm.controls['state'].disable();
        this.cityForm.controls['city'].disable();

        this.artistTypeForm = this.fb.group({
            artistType: this.fb.array([], [Validators.required, Validators.maxLength(3)]),
        });


        this.listenerForm = new UntypedFormGroup({
            fname: new UntypedFormControl("", [Validators.required, Validators.minLength(1), Validators.maxLength(50), this.validSongTitle.bind(this)]),
            lname: new UntypedFormControl("", [Validators.maxLength(50)]),
            email: new UntypedFormControl(this.register.email, [Validators.required, Validators.email, Validators.pattern(this.global.emailRegex), this.emailExists.bind(this),this.invalidEmail.bind(this)]),
            recaptchaReactive: new UntypedFormControl(null, Validators.required),

        });



        // //////////////////////////////////////////////////////////////////////////



        if (this.register.register_from == 5) {
            // global.trackEvent("Registration", "SignUp-Page", "Gmail");
            // this.global.gtmEvent('register', 'signup-page', 'gmail', this.data.userLastClickFrom);


        } else if (this.register.register_from == 2) {
            // global.trackEvent("Registration", "SignUp-Page", "Facebook");
            // this.global.gtmEvent('register', 'signup-page', 'facebook', this.data.userLastClickFrom);
        } else {
            // global.trackEvent("Registration", "SignUp-Page", "Manual");
            // this.global.gtmEvent('register', 'signup-page', 'manual', this.data.userLastClickFrom);
        }

        if (this.register.update && this.register.email != "" && this.register.email != null && this.register.email != undefined) {
            this.registerForm = new UntypedFormGroup({
                fname: new UntypedFormControl(this.register.fname, [
                    Validators.required,
                    Validators.minLength(1),
                    Validators.maxLength(50),
                    Validators.pattern(this.global.DtrackTitleRegex)
                ],),
                email: new UntypedFormControl(this.register.email, [Validators.required, Validators.email,
                Validators.pattern(this.global.emailRegex),
                this.emailExists.bind(this),
                this.invalidEmail.bind(this)]),
                username: new UntypedFormControl(this.register.username, []),
                mobile: new UntypedFormControl("", [Validators.maxLength(18), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
                password: new UntypedFormControl(this.register.password, []),
                recaptchaReactive: new UntypedFormControl(null, Validators.required),
            });
        } else if (this.register.update) {
            this.registerForm = new UntypedFormGroup({
                fname: new UntypedFormControl(this.register.fname, [
                    Validators.required,
                    Validators.minLength(1),
                    Validators.maxLength(50),
                    Validators.pattern(this.global.DtrackTitleRegex)
                ]),
                email: new UntypedFormControl(this.register.email, [
                    Validators.required,
                    Validators.email,
                    Validators.pattern(this.global.emailRegex),
                    this.emailExists.bind(this),
                    this.invalidEmail.bind(this)
                ]),

                username: new UntypedFormControl(this.register.username, []),
                mobile: new UntypedFormControl("", [Validators.maxLength(18), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
                password: new UntypedFormControl(this.register.password, []),
                recaptchaReactive: new UntypedFormControl(null, Validators.required),
            });
        } else {
            this.registerForm = new UntypedFormGroup({
                fname: new UntypedFormControl(this.register.fname, [
                    Validators.required,
                    Validators.minLength(1),
                    Validators.maxLength(50),
                    Validators.pattern(this.global.DtrackTitleRegex),
                ]),
                email: new UntypedFormControl(this.register.email, [
                    Validators.required,
                    Validators.email,
                    Validators.pattern(this.global.emailRegex),
                    this.emailExists.bind(this),
                    this.invalidEmail.bind(this)
                ]),
                // genre: new FormControl("", [Validators.required]),
                username: new UntypedFormControl(this.register.username, [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(50),
                    Validators.pattern(this.global.registerSongdewUrl),
                    this.validSongTitle.bind(this),
                    this.usernameExists.bind(this),
                ]),

                mobile: new UntypedFormControl("", [Validators.maxLength(18), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
                password: new UntypedFormControl(this.register.password, []),
                recaptchaReactive: new UntypedFormControl(null, Validators.required),
            });
        }

        this.getCountries();
        this.getArtistCat();
    }





 resetEmailErrors() {
        this.invalidEmailError = false;
        this.isEmailExist = false; 
    }

    onRegisterFormSubmit() {

        this.isRegisterFormSubmitted = true;
        if (this.registerForm.valid) {
            console.log('form is valid or not', this.registerForm);
            this.buttonclicked = true;
            this.registerLoading = true;
            this.api.checkEmail(this.registerForm.value.email).subscribe(
                (res) => {
                    this.isRegisterFormSubmitted = false;

                    this.registerError = false;
                    if (res.is_email_exists) {
                        this.buttonclicked = false;
                           if(res.msg &&  res.msg == 'Invalid email address'){
                            this.invalidEmailError = true;
                            this.isEmailExist = false;
                            // console.log('Invalid email address');
                            }else{
                                this.invalidEmailError = false;
                                this.isEmailExist = true;
                            }
                        if (this.global.isBrowser) {
                          
                            const tempEmail = $("#email").val();
                            this.registerForm.patchValue({ email: "" });
                            $("#email").val("");
                            this.registerForm.patchValue({ email: tempEmail });
                            $("#email").val(tempEmail);
                        }
                    } else {
                        this.isEmailExist = false;
                    }

                    if ((this.invalidEmailError || this.isEmailExist) && (this.register.token == "" || this.registerForm.value.email != this.register.email)) {
                        this.registerLoading = false;
                        // this.global.scrollToElem("#email");
                    } else {
                        this.api.checkUsername(this.registerForm.value.username)
                            .subscribe(
                                (res2) => {
                                    this.registerError = false;

                                    if (res2.is_username_exists) {
                                        if (this.global.isBrowser) {
                                            this.isUsernameExist = true;
                                            const tempUsername =
                                                $("#username").val();
                                            this.registerForm.patchValue({
                                                username: "",
                                            });
                                            $("#username").val("");
                                            this.registerForm.patchValue({
                                                username: tempUsername,
                                            });
                                            $("#username").val(tempUsername);
                                            this.suggestion = res2.suggest;
                                        }
                                        this.buttonclicked = false;

                                    } else {
                                        this.suggestion = "";
                                        this.isUsernameExist = false;
                                    }

                                    if (
                                        this.isUsernameExist &&
                                        (this.register.token == "" ||
                                            this.registerForm.value.username !=
                                            this.register.username)
                                    ) {
                                        this.registerLoading = false;
                                        // this.global.scrollToElem("#username");

                                    } else {

                                        var details = [];
                                        details = this.registerForm.value.fname.split(' ');
                                        let lname = details[1];
                                        this.registerForm.value.fname = details[0];
                                        if (lname == undefined) {
                                            lname = " ";
                                        } else {
                                            lname = details[1];
                                        }

                                        this.formValue = { ...this.registerForm.value, lname };



                                        this.api.register(
                                            this.formSteps,
                                            this.regType,
                                            this.formValue,
                                            this.register.register_from,
                                            this.register.access_token,
                                            this.register.provider,

                                        ).subscribe(
                                            (res3) => {

                                                if (res3.success) {
                                                    // console.log(this.data.userLastClickFrom)
                                                    // if (this.subscriptionRouteArray.includes(this.data.userLastClickFrom)) {
                                                    //     this.user.token = "Token " + res3.result.token;
                                                    //     this.user.email = res3.result.email;
                                                    //     // this.closeDialog();
                                                    //     this.verifyEmail();

                                                    // } else {
                                                    // this.formSteps = 3;
                                                    this.global.newUserFirstSession = true;
                                                    this.buttonclicked = false;
                                                    this.user.category = res3.category;
                                                    this.user.token = "Token " + res3.result.token;
                                                    this.user.id = res3.result.id;
                                                    this.user.type = res3.result.is_type;
                                                    this.user.slug = res3.result.slug_username;
                                                    this.user.fname = res3.result.profile.first_name;
                                                    this.user.lname = res3.result.profile.last_name;
                                                    this.user.bname = res3.result.band_name;
                                                    this.user.dp = res3.result.profile.profile_pic;
                                                    this.user.cover = res3.result.profile.cover_pic;
                                                    this.user.genre = [];
                                                    res3.result.genre_id.forEach((genre) => { this.user.genre.push(genre.name); });

                                                    this.user.mobile = res3.result.mobile;
                                                    this.user.email = res3.result.email;
                                                    this.user.isEmailVerified = res3.result.ismail_verify;
                                                    this.user.isMobVerified = res3.result.ismobile_verify;
                                                    this.user.songsCount = res3.result.songs_count;
                                                    this.user.videosCount = res3.result.videos_count;
                                                    this.user.isPwdSet = res3.result.has_usable_password;
                                                    this.user.iswhatsapp_verify = res3.result.iswhatsapp_verify;
                                                    this.user.whatsapp_number = res3.result.whatsapp_number;
                                
                                                    if (this.user.type == "Band") {
                                                        this.user.status = 2;
                                                    } else if (
                                                        this.user.type == "Artist") {
                                                        this.user.status = 1;
                                                    }

                                                    this.user.name = this.user.fname + " " + this.user.lname;
                                                    localStorage.setItem("category", JSON.stringify(this.user.category));
                                                    localStorage.setItem("token", JSON.stringify(this.user.token));
                                                    localStorage.setItem("id", JSON.stringify(this.user.id));
                                                    localStorage.setItem("type", JSON.stringify(this.user.type));
                                                    localStorage.setItem("slug", JSON.stringify(this.user.slug));
                                                    localStorage.setItem("fname", JSON.stringify(this.user.fname));
                                                    localStorage.setItem("lname", JSON.stringify(this.user.lname));
                                                    localStorage.setItem("bname", JSON.stringify(this.user.bname));
                                                    localStorage.setItem("dp", JSON.stringify(this.user.dp));
                                                    localStorage.setItem("cover", JSON.stringify(this.user.cover));

                                                    localStorage.setItem("mobile", JSON.stringify(this.user.mobile));
                                                    localStorage.setItem("email", JSON.stringify(this.user.email));
                                                    localStorage.setItem("isEmailVerified", JSON.stringify(this.user.isEmailVerified));
                                                    localStorage.setItem("isMobVerified", JSON.stringify(this.user.isMobVerified));
                                                    localStorage.setItem("songsCount", JSON.stringify(this.user.songsCount));
                                                    localStorage.setItem("videosCount", JSON.stringify(this.user.videosCount));
                                                    localStorage.setItem("isPwdSet", JSON.stringify(this.user.isPwdSet));
                                                    localStorage.setItem('iswhatsapp_verify', JSON.stringify(this.user.iswhatsapp_verify));
                                                    localStorage.setItem('whatsapp_number', JSON.stringify(this.user.whatsapp_number));
                                                    this.closeDialog();
                                                    // this.verifyEmail();
                                                    this.skipEmailVerification ? this.dialog.openSubscriptionDialog() : this.verifyEmail();
                                                    (<any>window).fbq('track', 'CompleteRegistration')

                                                    if (
                                                        this.register.register_from == 5) {
                                                        this.global.ga4Event('registration', 'second_form_success', this.user.slug, 'google', this.data.userLastClickFrom);


                                                    } else if (
                                                        this.register.register_from == 2) {
                                                        this.global.ga4Event('registration', 'second_form_success', this.user.slug, 'facebook', this.data.userLastClickFrom);

                                                    } else {
                                                        this.global.ga4Event('registration', 'second_form_success', this.user.slug, 'manual', this.data.userLastClickFrom);

                                                    }

                                                    if (
                                                        this.register.from == "/register" || this.register.from == "register") {
                                                        this.register.from = "/";
                                                    }
                                                    if (
                                                        this.register.type == undefined || this.register.type == null) {
                                                        this.register.type = "";
                                                    }

                                                    this.screenGuides();

                                                    if (this.user.status == 1 || this.user.status == 2) {
                                                        this.global.activeNavTabs = "dashboard";
                                                    } else {
                                                        this.global.activeNavTabs = "";
                                                    }


                                                    /************** Landing Page Logic ***********/
                                                    if (this.externalRedirect && this.externalRedirect !== "") {
                                                        // this.global.trackEvent("Registration", "Success-landing-page", this.externalRedirect);

                                                        const appendQueryParamns =
                                                            this.externalRedirect.split("?").length > 1 ? "&loginSuccess=1" : "?loginSuccess=1";
                                                        this.externalRedirect = this.externalRedirect + appendQueryParamns;
                                                        location.href = this.externalRedirect;
                                                    } else {
                                                        if (this.loginRedirectPage != undefined && this.loginRedirectPage != null &&
                                                            this.loginRedirectPage != "" && this.loginRedirectPage != "/") {
                                                            this.router.navigate([this.loginRedirectPage]);
                                                        } else {
                                                            if (this.register.from.indexOf("opportunity") > -1 || this.register.from.indexOf("opportunities") > -1) {
                                                                // this.global.trackEvent("Registration", "Success-landing-page", "landing page | " + this.register.from);
                                                                // this.router.navigate([this.register.from,]);
                                                            } else {
                                                                if (this.register.type == "") {
                                                                    // this.global.trackEvent("Registration", "Success-landing-page", "landing page | /mydashboard");
                                                                    this.router.navigate(["/mydashboard"]);
                                                                } else {
                                                                    // this.global.trackEvent("Registration", "Success-landing-page", "landing page | /" + this.register.from);
                                                                    this.router.navigate([this.register.from,], { queryParamsHandling: "merge" });
                                                                }

                                                            }
                                                        }
                                                    }
                                                    // }
                                                    /************** /Landing Page Logic ***********/
                                                } else {
                                                    this.registerLoading = false;
                                                    this.registerError = true;
                                                    this.registerErrorMsg = res3.error;
                                                    this.global.ga4Event('registration', 'error', this.user.slug, this.register.register_from == 5 ? 'google' : this.register.register_from == 2 ? 'facebook' : 'manual', this.data.userLastClickFrom, 'error:second_form');


                                                }
                                            },
                                            (err: HttpErrorResponse) => {
                                                this.registerLoading = false;
                                                this.registerError = true;

                                                if (err.error instanceof Error) {
                                                    this.registerErrorMsg = "Client-side error occured!";

                                                } else {
                                                    this.registerErrorMsg = "Server-side error occured!";

                                                }
                                            }
                                        );
                                    }
                                },
                                (err: HttpErrorResponse) => {
                                    this.registerLoading = false;
                                    this.registerError = true;

                                    if (err.error instanceof Error) {
                                        this.registerErrorMsg = "Client-side error occured!";

                                    } else {
                                        this.registerErrorMsg = "Server-side error occured!";

                                    }
                                }
                            );
                    }
                },
                (err: HttpErrorResponse) => {
                    this.registerLoading = false;
                    this.registerError = true;

                    if (err.error instanceof Error) {
                        this.registerErrorMsg = "Client-side error occured!";

                    } else {
                        this.registerErrorMsg = "Server-side error occured!";

                    }
                }
            );
        } else {



            if (this.registerForm.value.recaptchaReactive == null) {
                this.recaptchaError = true;
            } else {
                this.recaptchaError = false;
                this.show1();
            }




        }
    }


    onCityFormSubmit() {
        this.isCityFormSubmitted = true;
        this.cityForm.markAllAsTouched()   // Mark all as touched when submit form without touching field

        if (this.city.value != "" && this.city.value != "Other") {
            this.cityForm.patchValue({ otherCity: this.city.value });
        }

        if (this.cityForm.value.city == "Other" && this.cityForm.value.otherCity !== "") {
            this.cityForm.value.city = "Other" ? this.cityForm.value.otherCity : this.cityForm.value.city;
            // this.CityValue = this.cityForm.value.city
        }
        //this.cityForm.value.state == "Other" ? this.cityForm.value.otherState : this.cityForm.value.state;


        // this.CityValue = this.cityForm.value.city;

        if (this.cityForm.valid) {
            this.buttonclicked = true;



            let country = this.cityForm.value.country;
            let state = this.cityForm.value.state;
            let city = this.cityForm.value.city;
            this.formValue = { country, state, city },


                this.api.register(
                    this.formSteps,
                    this.regType,
                    this.formValue,
                    this.register.register_from,
                    this.register.access_token,
                    this.register.provider,

                ).subscribe(
                    (res) => {
                        this.isCityFormSubmitted = false;
                        this.buttonclicked = false;
                        this.global.ga4Event('registration', 'city_form_success', this.user.slug, this.register.register_from == 5 ? 'google' : this.register.register_from == 2 ? 'facebook' : 'manual', this.data.userLastClickFrom);
                        this.closeDialog();
                        this.verifyEmail();

                        // if (this.regType == 'Band') {
                        //     this.closeDialog();
                        //     this.verifyEmail();
                        // } else {
                        //     if (this.user.artistType.length > 0) {
                        //         this.closeDialog();
                        //         this.verifyEmail();
                        //     } 
                        // }

                    },
                    (error) => {

                    });

        }


    }


    onArtistTypeFormSubmit() {


        this.isartistFormSubmitted = true;

        if (this.selectedArtistType.length > 3) {
            this.checkboxError = true;
        }
        if (this.selectedArtistType.length > 0) {
            this.formValue = { artistType: this.selectedArtistType }

            this.buttonclicked = true;
            this.api.register(
                this.formSteps,
                this.regType,
                this.formValue,
                this.register.register_from,
                this.register.access_token,
                this.register.provider,

            ).subscribe(
                (res) => {
                    this.isartistFormSubmitted = false;
                    this.buttonclicked = false;

                    if (res.success == true) {

                        this.formSteps = 2;
                        this.global.ga4Event('registration', 'artist_type_form_success', this.user.slug, this.register.register_from == 5 ? 'google' : this.register.register_from == 2 ? 'facebook' : 'manual', this.data.userLastClickFrom);
                    }
                },
                (error) => {

                });


        }


    }


    onlistenerFormSubmit() {
        this.isListenerFormSubmitted = true;
        if (this.listenerForm.valid) {
            this.buttonclicked = true;
            let password = this.register.password;
            this.regType = "Listener";
            this.formValue = { ...this.listenerForm.value, password };

            this.api.register(
                this.formSteps,
                this.regType,
                this.formValue,
                this.register.register_from,
                this.register.access_token,
                this.register.provider,

            ).subscribe(
                (res3) => {
                    this.isListenerFormSubmitted = false;
                    this.buttonclicked = false;


                    if (res3.success) {
                        this.global.newUserFirstSession = true;

                        // this.closeDialog();
                        this.formSteps = 2;


                        this.user.category = res3.category;
                        this.user.token = "Token " + res3.result.token;
                        this.user.id = res3.result.id;
                        this.user.type = res3.result.is_type;
                        this.user.slug = res3.result.slug_username;
                        this.user.fname = res3.result.profile.first_name;
                        this.user.lname = res3.result.profile.last_name;
                        this.user.dp = res3.result.profile.profile_pic;
                        this.user.cover = res3.result.profile.cover_pic;
                        this.user.iswhatsapp_verify = res3.result.iswhatsapp_verify;
                        this.user.whatsapp_number = res3.result.whatsapp_number;
    
                        this.user.genre = [];





                        this.user.mobile = res3.result.mobile;
                        this.user.email = res3.result.email;
                        this.user.isEmailVerified = res3.result.ismail_verify;
                        this.user.isMobVerified = res3.result.ismobile_verify;
                        this.user.songsCount = res3.result.songs_count;
                        this.user.videosCount = res3.result.videos_count;
                        this.user.isPwdSet = res3.result.has_usable_password;


                        if (this.user.type == "Listener") {
                            this.user.status = 3;
                        }

                        this.user.name = this.user.fname + " " + this.user.lname;
                        localStorage.setItem("category", JSON.stringify(this.user.category));
                        localStorage.setItem("token", JSON.stringify(this.user.token));
                        localStorage.setItem("id", JSON.stringify(this.user.id));
                        localStorage.setItem("type", JSON.stringify(this.user.type));
                        localStorage.setItem("slug", JSON.stringify(this.user.slug));
                        localStorage.setItem("fname", JSON.stringify(this.user.fname));
                        localStorage.setItem("lname", JSON.stringify(this.user.lname));
                        localStorage.setItem("dp", JSON.stringify(this.user.dp));
                        localStorage.setItem("cover", JSON.stringify(this.user.cover));
                        // localStorage.setItem("genre", JSON.stringify(this.user.genre));
                        /*
                    localStorage.setItem('country', JSON.stringify(this.user.country));
                    localStorage.setItem('state', JSON.stringify(this.user.state));
                    localStorage.setItem('city', JSON.stringify(this.user.city));*/
                        localStorage.setItem("artistType", JSON.stringify(this.user.artistType));
                        localStorage.setItem("mobile", JSON.stringify(this.user.mobile));
                        localStorage.setItem("email", JSON.stringify(this.user.email));
                        localStorage.setItem("isEmailVerified", JSON.stringify(this.user.isEmailVerified));
                        localStorage.setItem("isMobVerified", JSON.stringify(this.user.isMobVerified));
                        localStorage.setItem("songsCount", JSON.stringify(this.user.songsCount));
                        localStorage.setItem("videosCount", JSON.stringify(this.user.videosCount));
                        localStorage.setItem("isPwdSet", JSON.stringify(this.user.isPwdSet));
                        localStorage.setItem('iswhatsapp_verify', JSON.stringify(this.user.iswhatsapp_verify));
                        localStorage.setItem('whatsapp_number', JSON.stringify(this.user.whatsapp_number));

                        if (
                            this.register.register_from == 5) {
                            this.global.ga4Event('registration', 'listener_form_success', this.user.slug, 'google', this.data.userLastClickFrom);

                        } else if (
                            this.register.register_from == 2) {
                            this.global.ga4Event('registration', 'listener_form_success', this.user.slug, 'facebook', this.data.userLastClickFrom);

                        } else {
                            this.global.ga4Event('registration', 'listener_form_success', this.user.slug, 'manual', this.data.userLastClickFrom);
                        }

                        if (
                            this.register.from == "/register" || this.register.from == "register") {
                            this.register.from = "/";
                        }
                        if (
                            this.register.type == undefined || this.register.type == null) {
                            this.register.type = "";
                        }

                        this.screenGuides();

                        if (this.user.status == 1 || this.user.status == 2) {
                            this.global.activeNavTabs = "dashboard";
                        } else {
                            this.global.activeNavTabs = "";
                        }

                        this.skipEmailVerification ? this.dialog.openSubscriptionDialog() : this.verifyEmail();

                        // this.verifyEmail();

                        /************** Landing Page Logic ***********/
                        if (this.externalRedirect && this.externalRedirect !== "") {
                            // this.global.trackEvent("Registration", "Success-landing-page", this.externalRedirect);

                            const appendQueryParamns = this.externalRedirect.split("?").length > 1 ? "&loginSuccess=1" : "?loginSuccess=1";
                            this.externalRedirect = this.externalRedirect + appendQueryParamns;
                            location.href = this.externalRedirect;
                        } else {
                            if (this.loginRedirectPage != undefined && this.loginRedirectPage != null &&
                                this.loginRedirectPage != "" && this.loginRedirectPage != "/") {
                                this.router.navigate([this.loginRedirectPage]);
                            } else {
                                if (this.register.from.indexOf("opportunity") > -1 || this.register.from.indexOf("opportunities") > -1) {
                                    // this.global.trackEvent("Registration", "Success-landing-page", "landing page | " + this.register.from);
                                    this.router.navigate([this.register.from,]);
                                } else {
                                    if (this.user.type == "Listener") {
                                        // this.global.trackEvent("Registration", "Success-landing-page", "landing page | /songs");
                                        this.router.navigate(["/songs",],
                                            { queryParamsHandling: "merge" }
                                        );
                                    } else {
                                        if (this.register.type == "") {
                                            // this.global.trackEvent("Registration", "Success-landing-page", "landing page | /mydashboard");
                                            this.router.navigate(["/mydashboard"]);
                                        } else {
                                            // this.global.trackEvent("Registration", "Success-landing-page", "landing page | /" + this.register.from);
                                            this.router.navigate([this.register.from,], { queryParamsHandling: "merge" });
                                        }
                                    }
                                }
                            }
                        }
                        /************** /Landing Page Logic ***********/
                    } else {
                        this.registerLoading = false;
                        this.registerError = true;
                        this.registerErrorMsg = res3.error;

                        this.global.ga4Event('registration', 'error', this.user.slug, this.register.register_from == 5 ? 'google' : this.register.register_from == 2 ? 'facebook' : 'manual', this.data.userLastClickFrom, 'error:listener_form');
                    }
                },
                (err: HttpErrorResponse) => {
                    this.registerLoading = false;
                    this.registerError = true;

                    if (err.error instanceof Error) {
                        this.registerErrorMsg = "Client-side error occured!";

                    } else {
                        this.registerErrorMsg = "Server-side error occured!";

                    }
                })
        } else {

            if (this.listenerForm.value.recaptchaReactive == null) {
                this.listernRecaptchaError = true;
            } else {
                this.listernRecaptchaError = false;
                this.show1();
            }

        }



    }

    selectedItems: number = 0;

    onCheckboxChange(e, type) {
        // this.videoSlugs = [];
        // this.myVideos.forEach(val => {
        //     if (val.slug_uservideo == i) {
        //         val.isSelected = !val.isSelected;
        //         this.videoSlugs.push(i)
        //     }
        //     else {
        //         val.isSelected = false;

        //     }

        if (e.target.checked) {
            this.selectedArtistType.push(type)
        } else {
            this.selectedArtistType = this.selectedArtistType.filter(item => item != type)
        }

        if (this.selectedArtistType.length > 3) {
            this.selectedArtistType = this.selectedArtistType.filter(item => item != type)
            e.target.checked = false;
        }



    }


    verifyEmail() {
        if (!this.user.isEmailVerified) {
            this.dialog.openVerifyEmailDialog(this.user.email, false);

        }

    }


    get fname() {
        return this.listenerForm.get("fname");
    }
    get lname() {
        return this.listenerForm.get("lname");
    }
    get email() {
        return this.registerForm.get("email");
    }
    get listenerEmail() {
        return this.listenerForm.get("email");
    }

    get mobile() {
        return this.registerForm.get("mobile");
    }
    get fnamee() {
        return this.registerForm.get("fname");
    }
    get username() {
        return this.registerForm.get("username");
    }
    get country() {
        return this.cityForm.get("country");
    }
    get state() {
        return this.cityForm.get("state");
    }
    get otherState() {
        return this.cityForm.get("otherState");
    }
    get city() {
        return this.cityForm.get("city");
    }
    get otherCity() {
        return this.cityForm.get("otherCity");
    }
    get artistType() {
        return this.artistTypeForm.get("artistType");
    }
    get recaptchaReactive() {
        return this.registerForm.get("recaptchaReactive");
    }
    get listenerRecaptchaReactive() {
        return this.listenerForm.get("recaptchaReactive");
    }

    ngOnInit() {


        this.registerForm.valueChanges.subscribe((x) => {
            // 
        });


    }




    checkUsername() {
        this.isUsernameExist = false;
        this.suggestion = "";

        if (this.registerForm.value.username.length > 2) {
            this.api
                .checkUsername(this.registerForm.value.username)
                .subscribe((res2) => {
                    // 
                    if (res2.is_username_exists) {
                        if (this.global.isBrowser) {
                            this.isUsernameExist = true;
                            const tempUsername = $("#username").val();
                            this.registerForm.patchValue({ username: "" });
                            $("#username").val("");
                            this.registerForm.patchValue({
                                username: tempUsername,
                            });
                            $("#username").val(tempUsername);
                            // this.global.scrollToElem("#username");
                            this.suggestion = res2.suggest;
                        }
                    } else {
                        this.suggestion = "";
                        this.isUsernameExist = false;

                        const tempUsername = $("#username").val();
                        this.registerForm.patchValue({
                            username: tempUsername,
                        });
                        $("#username").val(tempUsername);
                        // this.global.scrollToElem("#username");
                    }
                    this.usernameExists(this.registerForm.value.username);
                });
        }
    }

    suggestionFill(username) {
        if (this.global.isBrowser) {
            this.isUsernameExist = false;
            this.suggestion = "";
            this.registerForm.patchValue({ username: "" });
            $("#username").val("");
            this.registerForm.patchValue({ username: username });
            $("#username").val(username);
        }
    }





    getArtistCat() {
        this.api.getArtistCat().subscribe(
            (res) => {
                // 
                res.forEach((type) => {
                    this.artistTypes.push(type.name);
                });
            },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // 
                } else {
                    // 
                }
            }
        );
    }

    getCountries() {
        this.api.getCountries().subscribe(
            (res) => {
                this.countries = res;
            },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {

                } else {

                }
            }
        );
    }

    getCities(state) {

        this.api.getCities(state).subscribe(
            (res) => {
                this.cities = res;
                var other = []
                other['name'] = 'Other';
                other['id'] = 0;
                other['status'] = 1;
                this.cities.push(other);


            },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {

                } else {

                }
            }
        );
    }

    countryChanged() {

        if (this.cityForm.value.country == "") {
            this.states = [];
            // this.showstate = false;
            // this.cityForm.controls.state.disable();
            this.cityForm.controls['state'].disable();
        } else {

            this.countries.forEach((country) => {
                if (country.name == this.cityForm.value.country) {
                    this.states = country.states;


                }
            });
            // this.showstate = true;
            this.cityForm.controls['state'].enable();



        }
    }

    stateChanged() {


        if (this.cityForm.value.state == "") {
            this.cities = [];
            // this.showCity = false;

            // this.cityForm.controls.cities.disable();
            this.cityForm.controls['city'].disable();


        } else {
            // this.showCity = true;
            this.cities = [];
            this.states.forEach((state) => {
                if (state.name == this.cityForm.value.state) {
                    this.getCities(state.id);
                }

            });
            // this.cityForm.controls.cities.enable();
            this.cityForm.controls['city'].enable();


        }

    }

    dropvalueValidate(events: string, value: any) {
        if (events == "CountryValue") {
            this.CountryValue = value.name;
            this.cityForm.patchValue({
                country: value.name
            });
            this.StateValue = "";
            this.CityValue = "";
            this.cityForm.patchValue({
                state: ''
            });
            this.cityForm.patchValue({
                city: ''
            })

            // this.countryChanged(country);
            this.states = value.states
            this.cityForm.controls['state'].enable();
            this.cities = [];
            this.cityForm.controls['city'].disable();

        }

        if (events == "StateValue") {
            this.StateValue = value.name;
            this.cityForm.patchValue({
                state: value.name
            });
            this.CityValue = ""
            this.cityForm.patchValue({
                city: ''
            });
            // this.stateChanged();
            this.getCities(value.id);
            this.cityForm.controls['city'].enable();
        }
        if (events == "CityValue") {
            if (value == 'Other') {
                this.otherCity.setValidators([Validators.required, Validators.pattern(this.global.onlyAlpha)]);
                this.otherCity.updateValueAndValidity();
            } else {
                this.otherCity.setValidators(null);
                this.otherCity.updateValueAndValidity();
            }
            this.CityValue = value; this.cityForm.patchValue({
                city: value,
            })


        }

    };



    emailExists(control: AbstractControl): { [key: string]: boolean } | null {

        if (
            this.isEmailExist &&
            (this.register.token == "" || control.value != this.register.email)
        ) {
            return { emailExists: true };
        }
        return null;
    }

      invalidEmail(control: AbstractControl): { [key: string]: boolean } | null {

        if (this.invalidEmailError && (this.register.token == "" || control.value != this.register.email)) {
            return {  invalidEmail: true };
        }
        return null;
    }

    usernameExists(
        control: AbstractControl
    ): { [key: string]: boolean } | null {
        // 
        if (
            this.isUsernameExist &&
            (this.register.token == "" ||
                this.registerForm.value.username != this.register.username)
        ) {
            return { usernameExists: true };
        }
        return null;
    }

    validMobile(control: AbstractControl): { [key: string]: boolean } | null {
        if (control.value.length > 0 && control.value.length != 10) {
            return { validMobile: true };
        } else if (isNaN(control.value)) {
            return { validMobile: true };
        }

        return null;
    }

    validArtistTypes(
        control: AbstractControl
    ): { [key: string]: boolean } | null {
        if (control.value.length > 0) {
            return { validArtistTypes: true };
        }
        return null;
    }

    validSongTitle(
        control: AbstractControl
    ): { [key: string]: boolean } | null {
        let value;
        if (control.value != null) {
            value = control.value.trim();
        } else {
            value = "";
        }

        if (value == "") {
            return { validSongTitle: true };
        } else if (!this.global.registerSongdewUrl.test(control.value)) {
            return { validSongTitle: true };
        }
        return null;
    }

    keyPressNumbers(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }
    screenGuides() {
        this.api.getScreenGuide("dashboard").subscribe(
            (res) => {
                // 
                if (res.success) {
                    this.global.guides.dashboard = res.is_dashboard_sg_read;
                }
            },
            (err: HttpErrorResponse) => { }
        );

        this.api.getScreenGuide("claps").subscribe(
            (res) => {
                // 
                if (res.success) {
                    this.global.guides.claps = res.is_claps_sg_read;
                }
            },
            (err: HttpErrorResponse) => { }
        );

        this.api.getScreenGuide("schedule").subscribe(
            (res) => {
                // 
                if (res.success) {
                    this.global.guides.schedule = res.is_schedule_sg_read;
                }
            },
            (err: HttpErrorResponse) => { }
        );
    }


    listner() {
        this.formSteps = 4;
    }

    artist() {
        this.formSteps = 1;

    }

    closeDialog() {
        this.registerDialogRef.close('');
    }




    show(selectedChoice: boolean) {
        this.showForm3 = selectedChoice;

        //    this.isSelected=selectedChoice;
    }

    show1() {
        //    this.showForm3=false;
        //    
        RecaptchaComponent.prototype.ngOnDestroy = function () {
            if (this.subscription) {
                this.subscription.unsubcribe();
            }
        }
    }

    skip() {

        if ((this.user.bname == '' || this.user.bname == undefined || this.user.bname == null) && this.user.artistType.length < 1) {
            this.formSteps = 3;
            this.showForm3 = true;
        } else if (this.user.bname !== '' || this.user.bname !== undefined || this.user.bname !== null) {
            this.closeDialog();
            this.verifyEmail()
        }
    }





}
